import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetMainNavResponse } from './types/get-main-nav.type';

export const getMainNav = async (
	locale = 'en'
): Promise<AxiosResponse<GetMainNavResponse>> => {
	const response = await api.get(`/nav/${locale}/primary`);

	return response;
};
